const FETCH_USERS = 'curationList/FETCH_USERS';

const RESET = 'curationList/RESET';


export default {
  FETCH_USERS,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/userList/types.js